import type { AppConfig, CreateAppConfigInput } from './types';

const REGISTERED_CLIENT_IDS = [
  'chat',
  'frontdesk',
  'rcm',
  'aiphone',
  'onlinebooking',
  'recall',
];

function warnOnStaleConfig(config: AppConfig): void {
  if (!/\/api\/v2\/?$/.test(config.accountApiUrl)) {
    console.error(
      `@elva/platform: accountApiUrl "${config.accountApiUrl}" must end with /api/v2 (see VITE_ACCOUNT_API_URL).`,
    );
  }

  if (!REGISTERED_CLIENT_IDS.includes(config.clientId)) {
    console.error(
      `@elva/platform: clientId "${config.clientId}" is not a registered client app. ` +
        `Sign-in will fail with invalid_client. Expected one of: ${REGISTERED_CLIENT_IDS.join(', ')}.`,
    );
  }
}

export function createAppConfig(input: CreateAppConfigInput): AppConfig {
  const config: AppConfig = {
    appName: input.appName,
    clientId: input.clientId,
    tokenKey: input.tokenKey ?? 'elva_auth_token',
    refreshTokenKey: input.refreshTokenKey ?? 'elva_refresh_token',
    accountApiUrl: input.accountApiUrl,
    accountDomain: input.accountDomain.replace(/\/$/, ''),
    mainApiUrl: input.mainApiUrl,
    apiTimeout: input.apiTimeout ?? 60_000,
    loginCallbackPath: input.loginCallbackPath ?? '/loginok',
    accountLoginPath: input.accountLoginPath ?? '/login',
    publicPathPrefix: input.publicPathPrefix ?? '/public',
  };

  if (input.extraPublicPaths) {
    config.extraPublicPaths = input.extraPublicPaths;
  }
  const devAppOrigin = input.devAppOrigin;
  if (devAppOrigin) {
    config.devAppOrigin = devAppOrigin;
  }
  if (input.loginRedirectUri) {
    config.loginRedirectUri = input.loginRedirectUri;
  }

  warnOnStaleConfig(config);

  return config;
}
